import { useCallback, useState } from "react";
import useLogin from "../../Autenticacion/Hooks/useLogin";
import { ListarBackupService } from "../Services/ListarBackupService";

const MAP_TRIMESTRE_ID = {
    Q1: 1,
    Q2: 2,
    Q3: 3,
    Q4: 4,
};

const TRIMESTRES_DEFAULT = [
    { trimestreId: 1, trimestre: "Q1", disponible: false, estado: "No disponible", archivos: [] },
    { trimestreId: 2, trimestre: "Q2", disponible: false, estado: "No disponible", archivos: [] },
    { trimestreId: 3, trimestre: "Q3", disponible: false, estado: "No disponible", archivos: [] },
    { trimestreId: 4, trimestre: "Q4", disponible: false, estado: "No disponible", archivos: [] },
];

const normalizarTrimestres = (trimestres = []) => {
    const mapa = trimestres.reduce((accumulator, trimestre) => {
        accumulator[trimestre.trimestre] = {
            trimestreId: MAP_TRIMESTRE_ID[trimestre.trimestre] || 0,
            trimestre: trimestre.trimestre,
            disponible: Boolean(trimestre.disponible),
            estado: trimestre.estado || (trimestre.disponible ? "Disponible" : "No disponible"),
            archivos: trimestre.archivos || [],
        };
        return accumulator;
    }, {});

    return TRIMESTRES_DEFAULT.map((trimestreDefault) => (
        mapa[trimestreDefault.trimestre] || trimestreDefault
    ));
};

export function useBackupBaseDato() {
    const { usuario } = useLogin();
    const [listadoRespaldo, setListadoRespaldo] = useState([]);
    const [anioRespaldo, setAnioRespaldo] = useState(new Date().getFullYear());
    const [cargando, setCargando] = useState(false);

    async function fetchListadoBackup() {
        setCargando(true);
        try {
            const response = await ListarBackupService(usuario.id);
            if (response?.status === 200 && response?.data) {
                const { data } = response;
                setAnioRespaldo(data.anio || new Date().getFullYear());
                setListadoRespaldo(normalizarTrimestres(data.trimestres));
            }
        } catch (error) {
            console.log(error);
        } finally {
            setCargando(false);
        }
    }

    const getRespaldoTrimestre = useCallback(
        function () {
            if (!usuario?.id) {
                return;
            }

            fetchListadoBackup();
        },
        [usuario?.id]
    );

    return { listadoRespaldo, anioRespaldo, cargando, getRespaldoTrimestre };
}
